import GalleryCarousel from "./GalleryCarousel";

export default GalleryCarousel;
